import React, { Component } from 'react';
import styled from '@emotion/styled';

const UIMaxWidth = styled.div`
  display: block;
  max-width: 100%;
  margin: 0 auto;
  margin-bottom: ${props => (props.marginBottom ? props.marginBottom : '0')};
  overflow: ${props => (props.collapseMargins ? 'auto' : 'hidden')};
  background-color: ${props => {
    if (!props.isBackgroundColorForDesktopOnly) {
      if (props.backgroundColor) {
        return props.backgroundColor;
      } else {
        return 'transparent';
      }
    } else {
      return 'transparent';
    }
  }};
  @media (min-width: ${props => props.theme.tablet}) {
    overflow: ${props => (props.collapseMargins ? 'auto' : 'visible')};
    max-width: ${props => {
      if (props.fullWidth) {
        return '100%';
      }
      if (props.alternateWidth) {
        return '1400px';
      }
      return '1300px';
    }};
    padding: ${props => (props.alternateWidth ? '0' : '0 1.5rem')};
    background-color: ${props =>
      props.backgroundColor ? props.backgroundColor : 'transparent'};
  }
  @media print {
    max-width: 100%;
    background-color: transparent;
    overflow: visible;
  }
`;

class UIWidth extends Component {
  render() {
    return (
      <UIMaxWidth
        alternateWidth={this.props.alternateWidth}
        backgroundColor={this.props.backgroundColor}
        isBackgroundColorForDesktopOnly={
          this.props.isBackgroundColorForDesktopOnly
        }
        collapseMargins={this.props.collapseMargins}
        marginBottom={this.props.marginBottom}
        fullWidth={this.props.fullWidth}
      >
        {this.props.children}
      </UIMaxWidth>
    );
  }
}

export default UIWidth;
